// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGArtificialIntelligenceEnhanced = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsx("g", {
    clipPath: "url(#artificialIntelligenceEnhanced__clip0_4016_1261)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M20.964 11.964l-1.88 3.43c-.81 1.47-2.02 2.69-3.49 3.49l-3.43 1.88c-.54.3-.54 1.08 0 1.37l3.43 1.87c1.48.81 2.69 2.02 3.5 3.5l1.88 3.43c.3.54 1.08.54 1.37 0l1.88-3.43c.81-1.47 2.02-2.69 3.49-3.49l3.43-1.88c.54-.3.54-1.08 0-1.37l-3.43-1.88c-1.47-.81-2.69-2.02-3.49-3.49l-1.88-3.43c-.3-.54-1.08-.54-1.37 0h-.01zM7.114.964l-1.36 2.48c-.58 1.07-1.46 1.95-2.53 2.53l-2.48 1.36c-.39.22-.39.78 0 1l2.48 1.36c1.07.58 1.95 1.46 2.53 2.53l1.36 2.48c.22.39.78.39 1 0l1.36-2.49c.58-1.07 1.46-1.95 2.53-2.53l2.48-1.36c.39-.22.39-.78 0-1l-2.48-1.36c-1.07-.58-1.95-1.46-2.53-2.53L8.114.954c-.22-.39-.78-.39-1 0v.01z"
    })
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "artificialIntelligenceEnhanced__clip0_4016_1261",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    })
  })]
}));
SVGArtificialIntelligenceEnhanced.displayName = 'SVGArtificialIntelligenceEnhanced';
export default SVGArtificialIntelligenceEnhanced;